import { Controller } from "@hotwired/stimulus"

// Controls the sandbox key panel — key switching via selector and
// attaching a raw key via paste.
//
// Cooperates with the main SandboxController: after a successful switch
// or attach, it dispatches `sandbox-key:changed` so the main controller
// can re-enable the Ejecutar buttons.
export default class extends Controller {
  static targets = ["selector", "pasteInput", "pasteError"]
  static values = {
    activeKeyId: String,
    setActiveUrl: String,
    attachUrl: String
  }

  async switch(event) {
    const target = event.target
    const newId = target.value
    const option = target.options[target.selectedIndex]
    const isAttached = option.dataset.attached === "true"

    if (!isAttached) {
      // Raw not in session — revert selection and prompt for paste.
      target.value = this.activeKeyIdValue
      this.dispatch("need-paste", { detail: { keyId: newId } })
      alert("Esa llave no está conectada en esta sesión. Pégala en el modal para usarla.")
      return
    }

    try {
      await this.#postJson(this.setActiveUrlValue, { key_id: newId })
      this.activeKeyIdValue = newId
      this.#notifyChanged()
      window.location.reload()
    } catch (err) {
      alert(err.message || "No se pudo cambiar la llave.")
      target.value = this.activeKeyIdValue
    }
  }

  async attachFromForm(event) {
    event.preventDefault()
    this.#hideError()
    const raw = (this.pasteInputTarget.value || "").trim()
    if (!raw) {
      this.#showError("Pega la llave para continuar.")
      return
    }

    try {
      await this.#postJson(this.attachUrlValue, { raw_key: raw })
      this.pasteInputTarget.value = ""
      this.#notifyChanged()
      window.location.reload()
    } catch (err) {
      this.#showError(err.message || "No se pudo conectar la llave.")
    }
  }

  async #postJson(url, body) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": this.#csrfToken()
      },
      credentials: "same-origin",
      body: JSON.stringify(body)
    })

    const data = await response.json().catch(() => ({}))
    if (!response.ok) {
      throw new Error(data.error || `Error ${response.status}`)
    }
    return data
  }

  #csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }

  #notifyChanged() {
    this.dispatch("changed", { bubbles: true })
  }

  #showError(msg) {
    if (!this.hasPasteErrorTarget) return
    this.pasteErrorTarget.textContent = msg
    this.pasteErrorTarget.classList.remove("hidden")
  }

  #hideError() {
    if (!this.hasPasteErrorTarget) return
    this.pasteErrorTarget.classList.add("hidden")
  }
}
